import PropTypes from 'prop-types';
import styles from './footer.module.scss';
import Navigation from './navigation/navigation';
import { Logo, Address } from './logoAddress/logoAddress';
import SocialIcons from '../socialIcons/socialIcons';
import AppRating from './appRating/appRating';
import useWebView from '../../hooks/useWebView';

export default function Footer({
  navigation = [],
  brand = null,
  appRating = null,
  socialIcons = null,
  borderTop,
}) {
  const isWebView = useWebView();
  if (isWebView) return null;

  const hasSocial = Array.isArray(socialIcons) && socialIcons.length > 0;
  const hasNav = Array.isArray(navigation) && navigation.length > 0;
  const hasLogo = Boolean(brand?.logo?.path);
  const hasAddress = Boolean(brand?.address);

  return (
    <div className={styles.footer} data-testid="footer">
      <div
        className={`${styles.container} ${borderTop ? styles.borderTop : ''}`}
      >
        {hasNav && (
          <div className={styles.navigation} data-testid="footer-navigation">
            <Navigation navigation={navigation} />
          </div>
        )}
        {hasSocial && (
          <div className={styles.socialIcons} data-testid="footer-social-icons">
            <SocialIcons items={socialIcons} title="" />
          </div>
        )}
        {appRating && (
          <div className={styles.appRating} data-testid="footer-app-rating">
            <AppRating {...appRating} />
          </div>
        )}
        {(hasLogo || hasAddress) && (
          <div className={styles.brand} data-testid="footer-brand">
            {hasLogo && (
              <div className={styles.logo} data-testid="footer-logo">
                <Logo logo={brand.logo} />
              </div>
            )}
            {hasAddress && (
              <div className={styles.address} data-testid="footer-address">
                <Address address={brand.address} />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

Footer.propTypes = {
  navigation: PropTypes.array,
  brand: PropTypes.shape({
    logo: PropTypes.object,
    address: PropTypes.string,
  }),
  appRating: PropTypes.object,
  socialIcons: PropTypes.array,
  borderTop: PropTypes.bool,
};
